import React from 'react';

import {Categories} from './tabs/Categories';

export const Shop: React.FC = () => {
  return <Categories />;
};
